import * as React from 'react';
import { css } from 'aphrodite';
import { t } from '@citrite/translate';
import {
	Button,
	LoadingIconPrimary,
	withModals,
	WithModalsProps,
} from '@citrite/web-ui-component';
import { useBrowserExtensionPrompt } from 'App/Tile/useBrowserExtensionPrompt';
import { launchResourceWithPrompts } from 'App/Tile/utils';
import { useConfigurationContext } from 'Configuration/useConfigurationContext';
import { useLoadableResourceContext } from 'Workspace/ResourceProvider';
import { Resource } from 'Workspace/ResourceProvider/resourceTypes';
import { useUserContext } from 'Workspace/UserContext';
import { styles } from './OpenDesktopButton.styles';

export interface Props extends WithModalsProps {
	resource: Resource;
}

function _OpenDesktopButton({ resource, showModal }: Props) {
	const { workspaceConfiguration } = useConfigurationContext();
	const resourceContext = useLoadableResourceContext().value;
	const isInProgress = resourceContext.isInProgress(resource.id);
	const { userDetails } = useUserContext();
	const canShowBrowserExtensionPrompt = useBrowserExtensionPrompt();

	return isInProgress ? (
		<div className={css(styles.loadingContainer)}>
			<div className={css(styles.loadingIcon)}>
				<LoadingIconPrimary size={18} />
			</div>
			{t('Workspace:open_in_progress')}
		</div>
	) : (
		<Button.TextPrimary
			onClick={() =>
				launchResourceWithPrompts({
					workspaceConfiguration,
					resource,
					resourceContext,
					userDetails,
					canShowBrowserExtensionPrompt,
					showModal,
				})
			}
		>
			{t('Workspace:open_desktop')}
		</Button.TextPrimary>
	);
}

export const OpenDesktopButton = withModals(_OpenDesktopButton);
